import * as moment from 'moment'
import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { ProductItemBasicsArray } from '../../models/domain/product.item.basics';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TrainingEvent } from '../../models/domain/training.event';
import { TrainingClassArray } from '../../models/domain/training.class';
import { AdminItemArray } from '../../models/domain/admin.item';
import { AddTrainingEventRequest } from '../../models/ss-api/requests/add.training.event.request';
import { Router } from '@angular/router';

export interface IAddEventDialogModel {
    title: string;
    date: any;
}

@Component({
    selector: 'add-event-dialog',
    styleUrls: ['./add.event.dialog.css'],
    templateUrl: './add.event.dialog.html'
})

export class AddEventDialog extends DialogComponent<IAddEventDialogModel, boolean> implements IAddEventDialogModel, OnInit {
    IsBusy: boolean;
    title: string;
    date: any;
    Event: TrainingEvent = new TrainingEvent();
    EventDate: Date;
    EventTime: Date;
    EventForm: FormGroup;
    Products = ProductItemBasicsArray;
    TrainingClasses: TrainingClassArray;
    Trainers: AdminItemArray = new AdminItemArray();

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
        this.gb.GetStructureStudiosProductsBasics().then(data => {
            (<any>window).products = data.filter(p => p.ModuleType == 'structurestudios_licensing');
        });
    }

    ngOnInit() {
        this.IsBusy = false;
        this.getClasses();
        this.getTrainers();
        this.Event.EventDateTime = moment(this.date.date).add(1, 'd').toDate();
        this.EventForm = new FormGroup({
            'date': new FormControl(new Date(this.Event.EventDateTime), [Validators.required]),
            'time': new FormControl(moment('09:00', 'hh:mm').toDate(), [Validators.required]),
            'class': new FormControl(this.Event.TrainingClassID, [Validators.required]),
            'trainer': new FormControl(this.Event.TrainerID, [Validators.required])
        })
    }

    getClasses() {
        let disposable = this.api.GetAdminTrainingClasses().subscribe(request => {
            this.TrainingClasses = request.Data;
            disposable.unsubscribe();
        })
    }

    getTrainers() {
        let disposable = this.api.GetTrainers().subscribe(request => {
            this.Trainers = request.Data;
            disposable.unsubscribe();
        })
    }

    updateDefaultTrainer(event) {
        let trainingClass = this.TrainingClasses.find(c => c.ID == event.target.value);
        if (trainingClass.TrainerID) {
            this.Event.TrainerID = trainingClass.TrainerID;
            this.EventForm.controls['trainer'].setValue(trainingClass.TrainerID);
        } else {
            // If a trainer isn't found, set one temporarily.
            this.Event.TrainerID = 13;
            this.EventForm.controls['trainer'].setValue(13);
        }
    }

    async confirm() {
        this.IsBusy = true;
        if (!this.EventForm.valid)
            return false
        let request: AddTrainingEventRequest = new AddTrainingEventRequest();

        let date = moment(this.EventForm.controls['date'].value).format('YYYY-MM-DD');
        let time = moment(this.EventForm.controls['time'].value).format('hh:mm a');
        let eventDateTime = moment(date + ' ' + time, 'YYYY-MM-DD hh:mm a').toDate();

        request.EventDateTime = eventDateTime;
        request.TrainingClassID = this.EventForm.controls['class'].value;
        request.TrainerID = this.EventForm.controls['trainer'].value;

        let disposable = this.api.AddTrainingEvent(request).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Saved Successfully',
                    text: 'Event saved without any errors',
                    timer: 1500
                }).then(() => { }, () => { })
                this.close();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { }, () => { })
            }
            disposable.unsubscribe();
        })
    }

}
